import { faKeyboard } from '@fortawesome/free-solid-svg-icons';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@material-ui/core';
import React, {  useState } from 'react';
import IntlMessages from 'util/IntlMessages';
import Scanner from '../Scanner/Scanner';
import ScanningImage from '../ScanningImage/ScanningImage';
import styles from './Header.module.scss';
import TagDetails from './TagDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const WhatThisTag = () => {
    const [isScannerModalOpen, setIsScannerModalOpen] = useState(false);
    const [tagId, setTagId] = useState();




    const handleScanTag = (tag) => {
        tag && setTagId(tag);
    };

    const closeHandler = () => {
        setIsScannerModalOpen(false);
    };

    return (
        <>
            <IconButton
                className='p-2'
                size='small'
                onClick={() => setIsScannerModalOpen(true)}
            >
                <FontAwesomeIcon icon={faKeyboard} color='white' />
            </IconButton>
            {isScannerModalOpen && (
                <Dialog
                    className='text-center'
                    aria-labelledby='form-dialog-title'
                    maxWidth={'sm'}
                    fullWidth={true}
                    open={true}
                    onClose={closeHandler}
                >
                    <DialogTitle id='form-dialog-title'>
                        {<IntlMessages id={'shared.whatThisTagModal.title'} />}
                    </DialogTitle>
                    <DialogContent className='text-center'>
                        <Scanner
                            handleScan={handleScanTag}
                            scan={true}
                            autoFocus={false}
                        >
                            <ScanningImage />
                        </Scanner>
                        {tagId && (
                            <Box className='d-flex justify-content-center p-3'>
                                <TagDetails tagId={tagId} />
                            </Box>
                        )}
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
};

export default WhatThisTag;
